// General
import { useEffect } from "react";
// Services
import {
  useCentrobillPurchaseMutation,
  spiApi,
} from "../../../services/data.service";
// Static Data
import routeConst from "../../../const/routeConst";
// Redux
import { useSelector, useDispatch } from "react-redux";
import {
  updatePaymentProcessDialog,
  updateBuyCoinsDialog,
  updateCoinsPackageDialog,
} from "../../../redux/store/dialogStore";
import { updateErrorToast } from "../../../redux/store/toastStore";
// Custom Hooks
import useCustomNavigate from "./useCustomNavigate-hook";

const useCentrobillCoinsQuickPayment = () => {
  // API variables
  const [
    centrobillPurchase,
    {
      data: centrobillPurchaseData,
      error: centrobillPurchaseErrorData,
      isLoading: centrobillPurchaseLoading,
      isSuccess: centrobillPurchaseSuccess,
      isError: centrobillPurchaseError,
    },
  ] = useCentrobillPurchaseMutation();

  // Redux variables
  const selectedCoinPackage = useSelector(
    (state) => state.products.selectedCoinPackage
  );
  const centrobillCardDetail = useSelector(
    (state) => state.payment.centrobillCardDetail
  );
  const paymentTag = useSelector((state) => state.payment.paymentTag);
  const promoCode = useSelector((state) => state.products.promoCode);
  const dispatch = useDispatch();

  // Custom Hooks Functions
  const onNavigate = useCustomNavigate();

  // Lifecycle | Check for update | centrobillPurchase API Response
  useEffect(() => {
    if (centrobillPurchaseLoading) {
    } else if (centrobillPurchaseSuccess) {
      switch (centrobillPurchaseData?.status) {
        case 0:
        case 1:
          dispatch(updatePaymentProcessDialog(false));

          if (centrobillPurchaseData?.data?.url) {
            window.open(centrobillPurchaseData?.data?.url, "_self");
          } else {
            // Close buy coin dialog
            dispatch(updateBuyCoinsDialog(false));
            // Close coins package dialog
            dispatch(updateCoinsPackageDialog(false));
            // Redirect to Centrobill redirect page
            onNavigate(
              routeConst.payment.centrobill.path,
              false,
              `?status=successful&txn_id=${centrobillPurchaseData?.data?.txn_id}`
            );
          }
          break;
        default:
          dispatch(updatePaymentProcessDialog(false));

          const errorToastObj = {
            message: centrobillPurchaseData?.message,
            autoClose: 3000,
          };
          dispatch(updateErrorToast(errorToastObj));

          // Recall GET Payment Gateway API
          dispatch({
            type: `${spiApi.reducerPath}/invalidateTags`,
            payload: ["GetPaymentGatewayList"],
          });

          onNavigate(
            routeConst.payment.centrobill.path,
            false,
            "?status=failed&txn_id=123"
          );
          break;
      }
    } else if (centrobillPurchaseError) {
    }
  }, [
    centrobillPurchaseLoading,
    centrobillPurchaseSuccess,
    centrobillPurchaseError,
  ]);

  // Main Function
  const cardpayQuickPaymentFlow = () => {
    submitPayment();
  };

  // Part 1 |
  const submitPayment = () => {
    const payload = {
      payment_tag: paymentTag || "navbar-landing",
      product_hash_id: selectedCoinPackage?.product_hash_id,
      product_type: "coin",
      payment_token: centrobillCardDetail[0]?.token,
      promo_code: promoCode,
      redirect_url: `${window.origin}${routeConst.payment.centrobill.path}`,
    };
    centrobillPurchase(payload);

    dispatch(updatePaymentProcessDialog(true));
  };

  return cardpayQuickPaymentFlow;
};

export default useCentrobillCoinsQuickPayment;
